import styled, { keyframes } from 'styled-components'
import React from 'react'
import { GLOBAL_COLORS } from 'theme'

const LoaderWrapper = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => margin};
  font-size: 20px;
  position: relative;
  width: 34px;
  height: 11.5px;
  margin-left: 5px;
`

const Dot = styled.div<{ gray?: boolean }>`
  width: 4px;
  height: 4px;
  margin-top: 4px;
  border-radius: 50%;
  background: ${({ theme, gray }) => (gray ? GLOBAL_COLORS.coreGrey : theme.text1)};
  position: absolute;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;
`

const reveal = keyframes`
   from { transform: scale(0.001); }
    to { transform: scale(1); }
`

const slide = keyframes`
    to { transform: translateX(15px) }
`

const FirstDot = styled(Dot)`
  left: 0;
  animation-name: ${reveal};
`

const SecondDot = styled(Dot)`
  left: 0;
  animation-name: ${slide};
`
const ThirdDot = styled(Dot)`
  left: 15px;
  animation-name: ${slide};
`

const FourthDot = styled(Dot)`
  left: 30px;
  animation-name: ${reveal};
  animation-direction: reverse;
`

export const BalanceLoader = ({
  gray,
  margin,
}: {
  gray?: boolean
  margin?: string
}): JSX.Element => {
  return (
    <LoaderWrapper margin={margin}>
      <FirstDot gray={gray} />
      <SecondDot gray={gray} />
      <ThirdDot gray={gray} />
      <FourthDot gray={gray} />
    </LoaderWrapper>
  )
}
